'use strict';

class HEXColor {
  constructor(value, alpha) {
    this.value = value;
    this.alpha = alpha;
  }

  get red() {
    return ((this.value & 0xff0000) >> 16) / 255.0;
  }
  get green() {
    return ((this.value & 0x00ff00) >> 8) / 255.0;
  }
  get blue() {
    return ((this.value & 0x0000ff) >> 0) / 255.0;
  }
  asHex() {
    return Number(this.value).toString(16);
  }
}
HEXColor.fromHexString = function(hexString, alpha = 1) {
  return new HEXColor(parseInt(hexString, 16), alpha);
};
exports.HEXColor = HEXColor;

class SportTeamInfo {
  constructor(props = {}) {
    this.colors = props.colors;
  }
}
SportTeamInfo.Colors = class {
  constructor(props = {}) {
    this.first = props.first;
    this.second = props.second;
  }
};
exports.SportTeamInfo = SportTeamInfo;

class Coverage {
  constructor(properties) {
    const props = properties || { raw: 0 };
    this.raw = props.raw;
    this.countries = props.countries || [];
    this.regions = props.regions || [];
    this.localities = props.localities || [];
  }

  get isDefault() {
    return this.countries == [] && this.regions == [] && this.localities == [];
  }

  get isValid() {
    switch (this.raw) {
      case 2:
        return this.countries.length == 1;
      case 3:
        return this.countries.length == 1 && this.regions.length > 0;
      case 4:
        return (
          this.countries.length == 1 &&
          this.regions.length == 1 &&
          this.localities.length > 0
        );
      default:
        return true;
    }
  }

  isEqual(other) {
    if (!(other instanceof Coverage)) return false;

    return (
      this.countries == other.countries &&
      this.regions == other.regions &&
      this.localities == other.localities
    );
  }
}
Coverage.Level = Object.freeze({
  anywhere: 0,
  international: 1,
  national: 2,
  regions: 3,
  localities: 4,
  district: 5
});
exports.Coverage = Coverage;